import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

export interface SearchState {
	id_origen: number;
	id_destino: number;
	nombre_ciudadOrigen: string | undefined;
	nombre_ciudadDestino: string | undefined;
	fecha_ida: string | undefined;
	fecha_regreso: string | undefined;
	num_adultos: number;
	num_ninos: number;
	num_bebes: number;
	quiero_asiento: boolean;
	url_amigable: string | undefined;
	busqueda_full: number;
	indicador: number;
}

export const initialSearchState: SearchState = {
	id_origen: 0,
	id_destino: 0,
	nombre_ciudadOrigen: '',
	nombre_ciudadDestino: '',
	fecha_ida: '',
	fecha_regreso: '',
	num_adultos: 0,
	num_ninos: 0,
	num_bebes: 0,
	quiero_asiento: false,
	url_amigable: '',
	busqueda_full: 0,
	indicador: 0
};

export const SearchStore = signalStore(
	{ providedIn: 'root' },
	withState(initialSearchState),
	withMethods((store) => ({
		setOrigen: (id_origen: number) => patchState(store, { id_origen }),
		setDestino: (id_destino: number) => patchState(store, { id_destino }),
		setNombreCiudadDestino: (nombre_ciudadDestino: string) => patchState(store, { nombre_ciudadDestino }),
		setNombreCiudadOrigen: (nombre_ciudadOrigen: string) => patchState(store, { nombre_ciudadOrigen }),
		setFechaSalida: (fecha_ida: string) => patchState(store, { fecha_ida }),
		setFechaRetorno: (fecha_regreso: string) => patchState(store, { fecha_regreso }),
		setAdultos: (num_adultos: number) => patchState(store, { num_adultos }),
		setNinios: (num_ninos: number) => patchState(store, { num_ninos }),
		setBebes: (num_bebes: number) => patchState(store, { num_bebes }),
		setQuieroAsiento: (quiero_asiento: boolean) => patchState(store, { quiero_asiento }),
		setUrlAmigable: (url_amigable: string) => patchState(store, { url_amigable }),
		setBusquedaFull: (busqueda_full: number) => patchState(store, { busqueda_full }),
		setIndicador: (indicador: number) => patchState(store, { indicador }),
		updateAllFields: (newState: SearchState) => patchState(store, { ...newState }),
		resetState: () => patchState(store, { ...initialSearchState })
	}))
);
